import { render, staticRenderFns } from "./FiltersClientsProspectsLostRelaunch.vue?vue&type=template&id=4fd882d6"
import script from "./FiltersClientsProspectsLostRelaunch.vue?vue&type=script&lang=js"
export * from "./FiltersClientsProspectsLostRelaunch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports